module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels2_BW-p-1600-7fcf0204ed5ccd2965783e1e1271cea8.jpg";